export const API = "https://api.shotbybee.fr";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
